import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M4.73462 1.5837C4.73462 1.16949 4.39883 0.833702 3.98462 0.833702C3.57041 0.833702 3.23462 1.16949 3.23462 1.5837V2.2263C2.2148 2.54153 1.47388 3.49184 1.47388 4.6152V12.667C1.47388 14.0477 2.59316 15.167 3.97388 15.167H12.0256C13.4063 15.167 14.5256 14.0477 14.5256 12.667V4.6152C14.5256 3.49213 13.7851 2.54202 12.7657 2.22655V1.5837C12.7657 1.16949 12.4299 0.833702 12.0157 0.833702C11.6015 0.833702 11.2657 1.16949 11.2657 1.5837V2.1152H8.74988V1.5837C8.74988 1.16949 8.4141 0.833702 7.99988 0.833702C7.58567 0.833702 7.24988 1.16949 7.24988 1.5837V2.1152H4.73462V1.5837ZM4.47388 3.61129H11.5256C12.3541 3.61129 13.0256 4.28286 13.0256 5.11129V5.48125H2.97388V5.11129C2.97388 4.28286 3.64545 3.61129 4.47388 3.61129ZM13.0256 6.98125V12.167C13.0256 12.9954 12.3541 13.667 11.5256 13.667H4.47388C3.64545 13.667 2.97388 12.9954 2.97388 12.167V6.98125H13.0256Z';
const draw24px =
  'M18.75,3.34V2a.75.75,0,0,0-1.5,0V3.25h-4.5V2a.75.75,0,0,0-1.5,0V3.25H6.75V2a.75.75,0,0,0-1.5,0V3.35A3.73,3.73,0,0,0,2.32,7V19a3.75,3.75,0,0,0,3.75,3.75H17.94A3.75,3.75,0,0,0,21.69,19V7A3.75,3.75,0,0,0,18.75,3.34ZM20.19,19a2.25,2.25,0,0,1-2.25,2.25H6.07A2.25,2.25,0,0,1,3.82,19V9.72H20.19Zm0-10.78H3.82V7A2.25,2.25,0,0,1,6,4.75H18A2.25,2.25,0,0,1,20.19,7Z';
const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const CalendarIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'calendar'),
) as IconWithRender;

CalendarIcon.displayName = 'CalendarIcon';
CalendarIcon.propTypes = Icon.propTypes;
CalendarIcon.renderIcon = (props) => <CalendarIcon {...props} />;
export default CalendarIcon;
